import {collapseWhitespace, decodeHtmlEntities, stripEmoji, stripTags} from './converterUtils';

export function convertToAutoScout24(html: string): string {
  let text = collapseWhitespace(html);

  // Bold: <strong>/<b> -> **
  text = text.replace(/<\/?(?:strong|b)>/gi, '**');

  // Strip <em>/<i> and <u> tags (keep text)
  text = text.replace(/<\/?(?:em|i|u)>/gi, '');

  // Paragraph: <p> removed, </p> -> \\
  text = text.replace(/<p>/gi, '');
  text = text.replace(/<\/p>/gi, '\\\\');

  // Line break: <br> -> \\
  text = text.replace(/<br\s*\/?>/gi, '\\\\');

  // Ordered lists: <ol>...</ol> with numbered items
  text = text.replace(/<ol>(.*?)<\/ol>/gis, (_match, inner: string) => {
    let counter = 0;
    return inner.replace(/<li>(.*?)<\/li>/gis, (_m: string, content: string) => {
      const trimmed = content.trim();
      if (trimmed === '') {
        return '';
      }
      counter++;
      return `${counter}. ${trimmed}\\\\`;
    });
  });

  // Unordered lists: <ul>...</ul> -> \\* item\\
  text = text.replace(/<ul>(.*?)<\/ul>/gis, (_match, inner: string) =>
    inner.replace(/<li>(.*?)<\/li>/gis, (_m: string, content: string) => {
      const trimmed = content.trim();
      if (trimmed === '') {
        return '';
      }
      return `\\\\* ${trimmed}\\\\`;
    })
  );

  // Strip all remaining HTML tags
  text = stripTags(text);

  // Decode HTML entities
  text = decodeHtmlEntities(text);

  // Strip emoji
  text = stripEmoji(text);

  // Collapse 3+ consecutive \\ to single \\
  text = text.replace(/(\\\\){3,}/g, '\\\\');

  return text.trim();
}
